import * as React from 'react';
import b_ from 'b_';
import cn from 'classnames';
import NumberView, { Props as NumberProps } from '../NumberView';
import { Money, MoneyV2 } from '../../types/common';
import { symbols } from './symbols';

import './index.scss';

type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;

type Props = Omit<NumberProps, 'unit' | 'children'> & {
  children?: Money | MoneyV2 | null;
  cents?: boolean;
  displayFractionOnLongNumbers?: boolean;
};

export const currencyToSymbol = (currency: string) => symbols[currency] || currency;

const RegularSpan = ({ children, ...props }: React.HTMLAttributes<any>) => (
  <span {...props}>{children}</span>
);
const SvgSpan = ({ children, ...props }: React.HTMLAttributes<any>) => (
  <tspan {...props}>{children}</tspan>
);

const b = b_.with('money-view');

export const MoneyView: React.FC<Props> = ({
  precision,
  cents,
  className,
  placeholder,
  children: money,
  ...rest
}) => {
  const Span = rest.isSvg ? SvgSpan : RegularSpan;

  if (!money) {
    return (
      <Span className={className}>{typeof placeholder !== 'undefined' ? placeholder : 0}</Span>
    );
  }

  const { value, currency } = money;

  return (
    <NumberView
      exp={'exp' in money ? money.exp : null}
      className={cn(className, b())}
      precision={typeof precision === 'number' ? precision : 2}
      hideZeroFraction={!cents && !precision}
      unit={
        <Span>
          &thinsp;{currencyToSymbol(typeof currency === 'object' ? currency.code : currency)}
        </Span>
      }
      {...rest}
    >
      {+value}
    </NumberView>
  );
};

export default MoneyView;
